import {
  FETCH_ORDERS_SYNC,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_FAILURE,
  FETCH_ORDERS_BEGIN,
  RESET_REDUX,
  RESET_ON_IMPERSONATION,
} from "../../actions/actionTypes";

const initialState = {
  orders: [],
  totalNoOfOrders: 0,
  loading: false,
  errors: null,
  request: null,
  reqParams: null,
  initialDataCollected: false,
};

const ordersReducer = (state = initialState, action:any) => {
  switch (action.type) {
    case FETCH_ORDERS_BEGIN : {
      return {
        ...state,
        loading: true,
        orders: [],
        error: null,
        request: action.payload,
      }
    }
    case FETCH_ORDERS_SUCCESS : {
      return {
        ...state,
        loading: false,
        orders: action.payload.orderResponse.orders,
        totalNoOfOrders: action.payload.orderResponse.totalNoOfOrder,
        errors: null,
        initialDataCollected: true,
      }
    }
    case FETCH_ORDERS_FAILURE : {
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
        orders: [],
        totalNoOfOrders: 0,
        initialDataCollected: true,
      }
    }
    case FETCH_ORDERS_SYNC : {
      return {
        ...state,
        request: action.payload,
      }
    }
    case RESET_REDUX : {
      return {...initialState};
    }

    case RESET_ON_IMPERSONATION : {
      return {...initialState};
    }

    default: {
      return state;
    }
  }
}
export default ordersReducer;
